import { reduxKey } from './constants';
export const hasUsersOnPage = (state)=>state[reduxKey] && state[reduxKey]['usersOnPage'] ? true : false;
export const getUsersOnPage = (state)=>state[reduxKey] && state[reduxKey]['usersOnPage'] || {};
export const getServerFriends = (state, alpha)=>state[reduxKey] && state[reduxKey]['friends'][alpha] || [];
export const getFriendsPage = (state, alpha)=>state[reduxKey] && state[reduxKey].friendPages[alpha] || 0;

//# sourceMappingURL=selectors.js.map